import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static targets = ["select"];

  connect() {
    this.selectTargets.forEach((element) => {
      const queryUrl = element.dataset.ticketFilterQueryUrl;
      const slim = new SlimSelect({
        select: element
      });

      // Ensure the input field exists before adding an event listener
      const inputField = element.parentElement.querySelector('.ss-main input');
      if (inputField) {
        inputField.addEventListener('input', (event) => {
          const query = event.target.value;
          if (query.length > 2) {
            this.fetchSearchResults(queryUrl, query, slim);
          }
        });
      }
    });
  }

  fetchSearchResults(queryUrl, query, slim) {
    fetch(`${queryUrl}?q=${encodeURIComponent(query)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        // Clear current options
        slim.setData([]);

        // Map server response to options
        const options = data.map(item => ({ text: item.uid, value: item.id }));

        // Update Slim Select with new options
        slim.setData(options);
      })
      .catch(error => console.error('Error fetching data:', error));
  }
}
